var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orgManage"},[_c('div',{staticClass:"panel-left"},[_c('slider')],1),_c('div',{staticClass:"pannel-right"},[_c('userlist')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }